import { render, staticRenderFns } from "./LaterCard.vue?vue&type=template&id=38305338&scoped=true&"
import script from "./LaterCard.vue?vue&type=script&lang=js&"
export * from "./LaterCard.vue?vue&type=script&lang=js&"
import style0 from "./LaterCard.vue?vue&type=style&index=0&id=38305338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38305338",
  null
  
)

export default component.exports